import { FC, memo } from 'react';
import classNames from 'classnames';
import styles from './Dot.scss';

export const dotSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
} as const;

export type DotSizesType = (typeof dotSizes)[keyof typeof dotSizes];

type Props = {
    size: DotSizesType;
    isActive?: boolean;
};

const Dot: FC<Props> = ({ size, isActive }) => {
    return (
        <span
            data-tn="dot"
            className={classNames(styles.wrapper, styles[size], {
                [styles.active]: isActive,
            })}
        />
    );
};

export default memo(Dot);
